import React, { useState, useEffect, useContext, useMemo } from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import axios from "axios";
import {
  Table,
  Button,
  Row,
  Col,
  ButtonGroup,
  Input,
  Label,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from "reactstrap";
import Header from "../../../layout/Header/Header";
import { jsPDF } from "jspdf";
import "jspdf-autotable";
import autoTable from "jspdf-autotable";
import ExportJsonExcel from "js-export-excel";
import encode from "nodejs-base64-encode";
import SweetAlert from "sweetalert2-react";
import Swal from "sweetalert2";
import { TableHeader, Pagination, Search } from "../../../DataTable";
import useFullPageLoader from "../../../hooks/useFullPageLoader";
import moment from "moment";
import { useTranslation } from "react-i18next";
import i18next from "i18next";
function ListadoGastos() {
  const { user } = useContext(AuthContext);
  const URL_LOGS = process.env.REACT_APP_URL_LOGS;
  const URL_GASTOS = process.env.REACT_APP_URL_GASTOS;
  const URL_SEND_MAIL_ATT = process.env.REACT_APP_URL_SEND_MAIL_ATT;
  const URL_PROVEEDORES = process.env.REACT_APP_URL_PROVEEDORES;
  const URL_CONCEPTOS_GASTOS = process.env.REACT_APP_URL_CONCEPTOS_GASTOS;
  const [t, i18n] = useTranslation("global");
  let date = new Date();
  let hoy = moment(date).format("YYYY-MM-DD");

  let inicio = new Date();
  inicio.setDate(inicio.getDate() - 30);
  let inicio2 = moment(inicio).format("YYYY-MM-DD");

  const [selectedFechaInicio, setSelectedFechaInicio] = useState(inicio2);
  const [selectedFechaFin, setSelectedFechaFin] = useState(hoy);

  const [modalMail, setModalMail] = useState(false);
  const toggleMail = () => setModalMail(!modalMail);
  const [mailTo, setMailTo] = useState("");

  const [modalEdit, setModalEdit] = useState(false);
  const toggleEdit = () => setModalEdit(!modalEdit);
  const [idEdit, setIdEdit] = useState();
  const [fecha, setFecha] = useState(hoy);
  const [totalUSD, setTotalUSD] = useState(0);
  const [tipoCambio, setTipoCambio] = useState(1);
  const [total, setTotal] = useState(0);
  const [descripcion, setDescripcion] = useState("NA");
  const [conceptosGastos, setConceptosGastos] = useState([]);
  const [selectedConcepto, setSelectedConcepto] = useState("");
  const [proveedores, setProveedores] = useState([]);
  const [selectedProveedor, setSelectedProveedor] = useState("");
  const [moneda, setMoneda] = useState("");
    const [validado, setValidado] = useState("");
    const [autorizado, setAutorizado] = useState("");
        const [selectedActivo, setSelectedActivo] = useState('Si');

  //--- Pagination
  const [comments, setComments] = useState([]);
  const [loader, showLoader, hideLoader] = useFullPageLoader();
  const [totalItems, setTotalItems] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [search, setSearch] = useState("");
  // IDs desmarcados para el PDF. Vacío = todos incluidos (default).
  const [excludedPdfIds, setExcludedPdfIds] = useState([]);
  const [sorting, setSorting] = useState({ field: "", order: "" });

  const ITEMS_PER_PAGE = 50;

useEffect(() => {
  const headers = {
    Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
  };

  // ✅ IDs de conceptos de nómina (bloqueados cuando NO tiene permiso)
  const IDS_CONCEPTO_NOMINA = [
   "69691f44300cc49682e69bb1",
    "696937772f731d1e9c1544b4",
    "69822d5100c9e59ee3a5acd9",
    "69822d6500c9e59ee3a5acde",
    "69822d6b00c9e59ee3a5ace3",
    "69822d7200c9e59ee3a5ace8",
    "69822d7900c9e59ee3a5aced",
    "69822d7300c9e59ee3a5ace8",
  ];

  // helper: true si el usuario NO puede ver nómina
  const noVeNomina = !user?.gastosNomina;

  // helper: filtra por concepto nómina
  const filtraNomina = (arr = []) =>
    noVeNomina
      ? arr.filter((x) => {
          const idConcepto =
            x?.conceptosGastos?.[0]?._id || x?.idConceptosGastos || x?._id;

          return !IDS_CONCEPTO_NOMINA.includes(idConcepto);
        })
      : arr;

  // ==========================
  // 1) GASTOS (listado)
  // ==========================
  axios
    .get(`${URL_GASTOS}Fechas/${selectedFechaInicio}/${selectedFechaFin}`, {
      headers,
    })
    .then((response) => {
      let allGastos = response.data || [];

      // 🔒 Filtrar GASTOS por concepto nómina
      allGastos = filtraNomina(allGastos);

      let arrayTabla = allGastos
        .sort((a, b) => (a.fecha < b.fecha ? 1 : -1))
        .map((a) => {
          const fechaGasto = new Date(a.fecha);
          const fechaActual = new Date();

          let mesEdicion =
            fechaActual.getDate() < 15
              ? fechaActual.getMonth() - 1
              : fechaActual.getMonth();
          let year = fechaActual.getFullYear();

          if (mesEdicion < 0) {
            mesEdicion = 11;
            year -= 1;
          }

          const mesEdicionFormatted = (mesEdicion + 1)
            .toString()
            .padStart(2, "0");
          const fechaLimiteEdicion = `${year}-${mesEdicionFormatted}-15`;
          const fechaGastoFormatted = fechaGasto.toISOString().split("T")[0];

          const poderEditar =
            fechaGastoFormatted > fechaLimiteEdicion || a.tipoCambio === 0
              ? "Si"
              : "No";

          return {
            _id: a._id,
            numero: a.idGasto,
            fecha: a.fecha,
            descripcion: a.descripcion,
            totalUSD: a.totalUSD,
            tipoCambio: a.tipoCambio,
            total: a.total,
            concepto: a?.conceptosGastos?.[0]?.name,
            proveedor: a?.proveedores?.[0]?.name,
            idProveedor: a?.proveedores?.[0]?._id,
            datosBancarios: a?.proveedores?.[0]?.datosBancarios,
            idConceptosGastos: a?.conceptosGastos?.[0]?._id,
            moneda: a.moneda,
            saldo: a.saldo,
            is_active: a.is_active,
            poderEditar,
            validado: a.validado,
            autorizado: a.autorizado,
            banco: `${a?.bancos?.[0]?.banco || ""} ${
              a?.bancos?.[0]?.cuenta || ""
            }`.trim(),
            idBanco: a?.bancos?.[0]?._id,
          };
        })
        .filter(Boolean);

      setComments(arrayTabla);
    })
    .catch((err) => console.log(err));

  // ==========================
  // 2) CONCEPTOS (selects)
  // ==========================
  axios
    .get(URL_CONCEPTOS_GASTOS, { headers })
    .then((res) => {
      let allConceptosGastos = res.data || [];

      // 🔒 Filtrar CONCEPTOS por concepto nómina
      if (noVeNomina) {
        allConceptosGastos = allConceptosGastos.filter(
          (c) => !IDS_CONCEPTO_NOMINA.includes(c._id)
        );
      }

      setConceptosGastos(allConceptosGastos);
    })
    .catch((err) => console.log(err));

  // ==========================
  // 3) PROVEEDORES
  // ==========================
  axios
    .get(URL_PROVEEDORES, { headers })
    .then((res) => setProveedores(res.data || []))
    .catch((err) => console.log(err));
}, [user?.gastosNomina, selectedFechaInicio, selectedFechaFin]);



  let totalTabla = 0;

function PDFTabla() {
  // =========================
  // Helpers
  // =========================
  const safeLower = (v) => (v ?? "").toString().toLowerCase();

  const formatUSD = (v) =>
    new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD",
      maximumFractionDigits: 2,
      roundingIncrement: 5,
    }).format(Number(v || 0));

  // ✅ FIX: calcula alto real del recuadro según líneas envueltas
  const drawDatosBancarios = (doc, datos, startX, startY, maxWidth = 200) => {
    if (!datos) return startY;

    let y = startY;
    const innerPad = 3;
    const lineH = 5;

    const valueX = startX + 45;
    const valueW = maxWidth - 50;

    doc.setFontSize(10);
    doc.setFont(undefined, "bold");
    doc.text("Datos bancarios del proveedor", startX, y);
    doc.setFont(undefined, "normal");
    y += 6; // antes 2, muy pegado

    const kvs = [];
    if (typeof datos === "string") {
      kvs.push(["Datos", String(datos)]);
    } else if (typeof datos === "object") {
      const preferidos = [
        "beneficiario",
        "banco",
        "cuenta",
        "clabe",
        "swift",
        "aba",
        "referencia",
        "moneda",
        "direccionBanco",
      ];
      const vistos = new Set();

      preferidos.forEach((k) => {
        if (datos[k] != null && datos[k] !== "") {
          kvs.push([k, String(datos[k])]);
          vistos.add(k);
        }
      });

      Object.keys(datos).forEach((k) => {
        if (!vistos.has(k) && datos[k] != null && datos[k] !== "") {
          kvs.push([k, String(datos[k])]);
        }
      });

      if (kvs.length === 0) kvs.push(["Información", JSON.stringify(datos)]);
    } else {
      return y;
    }

    // 1) Precalcular líneas y alto real
    const items = kvs.map(([labelRaw, value]) => {
      const label = labelRaw.charAt(0).toUpperCase() + labelRaw.slice(1);
      const lines = doc.splitTextToSize(String(value), valueW);
      const rowH = Math.max(lineH, lines.length * (lineH - 0.5));
      return { label, lines, rowH };
    });

    const contentHeight =
      innerPad * 2 + items.reduce((acc, it) => acc + it.rowH, 0);

    // 2) Dibujar cuadro con alto correcto
    doc.roundedRect(
      startX - 2,
      y - innerPad,
      maxWidth + 4,
      contentHeight,
      2,
      2
    );

    // 3) Pintar texto dentro
    let yy = y;
    for (const it of items) {
      doc.setFont(undefined, "bold");
      doc.text(`${it.label}:`, startX, yy);
      doc.setFont(undefined, "normal");
      doc.text(it.lines, valueX, yy);
      yy += it.rowH;
    }

    // cursor después del recuadro
    return y - innerPad + contentHeight + 2;
  };

  // =========================
  // 1) SEARCH (idéntico a tu useMemo)
  // =========================
  let computedComments = [...(comments || [])];

  if (search) {
    const s = safeLower(search);
    computedComments = computedComments.filter(
      (comment) =>
        safeLower(comment.concepto).includes(s) ||
        safeLower(comment.proveedor).includes(s) ||
        safeLower(comment.validado).includes(s) ||
        safeLower(comment.autorizado).includes(s) ||
        safeLower(comment.descripcion).includes(s)
    );
  }

  // =========================
  // 2) FILTROS (los tuyos)
  // =========================
  computedComments = computedComments.filter((c) => {
    return (
      (selectedFechaInicio == 0 || selectedFechaInicio <= c.fecha) &&
      (validado == 0 || validado == c.validado) &&
      (autorizado == 0 || autorizado == c.autorizado) &&
      (selectedFechaFin == 0 || selectedFechaFin >= c.fecha) &&
      (selectedActivo == 0 || selectedActivo == c.is_active) &&
      // ✅ excluir los gastos desmarcados en la columna "Incluir PDF"
      !excludedPdfIds.includes(String(c._id))
    );
  });

  // =========================
  // 3) AGRUPAR POR PROVEEDOR
  // =========================
  let totalGeneral = 0;

  const grupos = new Map();
  for (const c of computedComments) {
    const provNombre = c.proveedor ?? "SIN PROVEEDOR";
    const datosBancarios = c.datosBancarios ?? c.cuentaBancaria ?? null;

    const totalNum = Number(c.total || 0);
    totalGeneral += totalNum;

    if (!grupos.has(provNombre)) {
      grupos.set(provNombre, {
        datosBancarios: datosBancarios ?? null,
        rows: [],
        total: 0,
      });
    }

    const g = grupos.get(provNombre);
    if (!g.datosBancarios && datosBancarios) g.datosBancarios = datosBancarios;

    g.rows.push([
      c.fecha,
      c.concepto,
      c.descripcion,
      c.validado,
      c.autorizado,
      formatUSD(c.total),
    ]);

    g.total += totalNum;
  }

  const gruposOrdenados = Array.from(grupos.entries()).sort(([a], [b]) =>
    String(a).localeCompare(String(b), "es", { sensitivity: "base" })
  );

  // =========================
  // 4) PDF
  // =========================
  const doc = new jsPDF("landscape");

  try {
    const img = new Image();
    img.src = process.env.PUBLIC_URL + "Logo-Lynqro-PDF.png";
    doc.addImage(img, "png", 230, 30, 45, 15);
  } catch {}
  try {
    const img2 = new Image();
    img2.src = process.env.PUBLIC_URL + "logoInstitucion.png";
    doc.addImage(img2, "png", 140, 15, 25, 25);
  } catch {}

  doc.setFontSize(14);
  doc.text("Detalle de Gastos", 20, 25);

  const head = [
    ["Fecha", "Concepto", "Descripcion", "Validado", "Autorizado", "Importe"],
  ];
  const margenIzq = 20;
  let cursorY = 45;

  for (const [provNombre, g] of gruposOrdenados) {
    if (cursorY > 180) {
      doc.addPage("landscape");
      cursorY = 20;
    }

    doc.setFontSize(12);
    doc.setFont(undefined, "bold");
    doc.text(`Proveedor: ${provNombre}`, margenIzq, cursorY);
    doc.setFont(undefined, "normal");
    cursorY += 6;

    // ✅ ya regresa el cursor bien (alto real del recuadro)
    cursorY = drawDatosBancarios(doc, g.datosBancancarios ?? g.datosBancarios, margenIzq, cursorY, 200) + 2;

    doc.autoTable({
      head,
      body: g.rows,
      startY: cursorY,
      styles: { fontSize: 10 },
      margin: { left: margenIzq, right: 14 },
      showFoot: "lastPage",
      foot: [["", "", "", "", "Total Proveedor", formatUSD(g.total)]],
    });

    cursorY = doc.lastAutoTable.finalY + 10;
  }

  if (cursorY > 180) {
    doc.addPage("landscape");
    cursorY = 20;
  }

  doc.setFont(undefined, "bold");
  doc.text("Total general:", margenIzq, cursorY);
  doc.setFont(undefined, "normal");
  doc.text(formatUSD(totalGeneral), margenIzq + 35, cursorY);

  doc.save("DetalleGastos_por_proveedor.pdf");
}


function excel() {
  const safeLower = (v) => (v ?? "").toString().toLowerCase();

  // =========================
  // 1) SEARCH (idéntico a tu useMemo)
  // =========================
  let computedComments = [...(comments || [])];

  if (search) {
    const s = safeLower(search);
    computedComments = computedComments.filter(
      (comment) =>
        safeLower(comment.concepto).includes(s) ||
        safeLower(comment.proveedor).includes(s) ||
        safeLower(comment.validado).includes(s) ||
        safeLower(comment.autorizado).includes(s) ||
        safeLower(comment.descripcion).includes(s)
    );
  }

  // =========================
  // 2) FILTROS
  // =========================
  const dataExcelLimpia = computedComments
    .map((c) => {
      if (
        (selectedFechaInicio == 0 || selectedFechaInicio <= c.fecha) &&
        (validado == 0 || validado == c.validado) &&
        (autorizado == 0 || autorizado == c.autorizado) &&
        (selectedFechaFin == 0 || selectedFechaFin >= c.fecha) &&
        (selectedActivo == 0 || selectedActivo == c.is_active) && // ✅ is_active
        // ✅ excluir los gastos desmarcados en la columna "Incluir PDF"
        !excludedPdfIds.includes(String(c._id))
      ) {
        return {
          Fecha: c.fecha,
          Concepto: c.concepto,
          Descripcion: c.descripcion,
          Validado: c.validado,
          Autorizado: c.autorizado,
          Importe: c.total,
        };
      }
      return null;
    })
    .filter(Boolean);

  // =========================
  // 3) EXPORT
  // =========================
  var option = {};
  option.fileName = `DetalleGastos-${selectedFechaInicio}-${selectedFechaFin}`;
  option.datas = [
    {
      sheetData: dataExcelLimpia,
      sheetName: `DetalleGastos`,
      sheetFilter: [
        "Fecha",
        "Concepto",
        "Descripcion",
        "Validado",
        "Autorizado",
        "Importe",
      ],
      sheetHeader: [
        "Fecha",
        "Concepto",
        "Descripcion",
        "Validado",
        "Autorizado",
        "Importe",
      ],
    },
  ];

  var toExcel = new ExportJsonExcel(option);
  toExcel.saveExcel();
}

  function enviaMail() {
    let total = 0;
    const data = comments.map((c) => {
      if (
        (selectedFechaInicio == 0 || selectedFechaInicio <= c.fecha) &&
        (validado == 0 || validado == c.validado) &&
        (autorizado == 0 || autorizado == c.autorizado) &&
        (selectedFechaFin == 0 || selectedFechaFin >= c.fecha)&&
      (selectedActivo == 0 || selectedActivo == c.is_active) &&
      // ✅ excluir los gastos desmarcados en la columna "Incluir PDF"
      !excludedPdfIds.includes(String(c._id))
      ) {
        total = total + c.total;
        const importePDF = new Intl.NumberFormat("en-US", {
          style: "currency",
          currency: "USD",
          maximumFractionDigits: 2,
          roundingIncrement: 5,
        }).format(c.total);
        return [c.fecha, c.concepto, c.descripcion, c.validado, c.autorizado, importePDF];
      }
    });
    const dataPDF = Object.values(data);
    const dataPDFLimpia = dataPDF.filter(function (el) {
      return el != null;
    });
    const doc = new jsPDF("landscape");
    var img = new Image();
    img.src = process.env.PUBLIC_URL + "Logo-Lynqro-PDF.png";
    doc.addImage(img, "png", 230, 30, 45, 15);
    var img2 = new Image();
    img2.src = process.env.PUBLIC_URL + "logoInstitucion.png";
    doc.addImage(img2, "png", 140, 15, 25, 25);
    doc.text("Detalle de Gastos", 20, 25);
    doc.autoTable({
      head: [["Fecha", "Concepto", "Descripcion", "Validado", "Autorizado", "Importe"]],
      body: dataPDFLimpia,
      startY: 45,
      foot: [
        [
          "",
          "",
          "",
          "",
          "Total",
          new Intl.NumberFormat("en-US", {
            style: "currency",
            currency: "USD",
            maximumFractionDigits: 2,
            roundingIncrement: 5,
          }).format(total),
        ],
      ],
      showFoot: "lastPage",
    });
    var att = doc.output("arraybuffer");
    var base64File = encode.encode(att, "base64");

    // Envia el Mail
    axios
      .post(
        URL_SEND_MAIL_ATT,
        {
          subject: "Lista de Gastos",
          email: mailTo,
          fileName: "ListaGastos.pdf",
          att: base64File,
          text: `<table border="0" cellpadding="0" cellspacing="0" width="100%">
         <th><img width="${process.env.REACT_APP_TAMANO_LOGO_MAIL}" align="center" src="${process.env.REACT_APP_LINK_SISTEMA}logoInstitucion.png" /></th>
         <tr align="center" style="font-size:30px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>${process.env.REACT_APP_NOMBRE_INSTITUCION}</tr>
         <tbody>
         <tr style="font-size:20px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>Hola,</tr>
         <tr style="font-size:20px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>Adjunto encontraras la lista de Gastos.</tr>
         </tbody>
         <tr style="font-size:16px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px"><br>Favor de no responder este correo, para cualquier duda favor de comunicarse al ${process.env.REACT_APP_TELEFONO_INSTITUCION}</tr>
         <tr align="right"><br>Powered by <a href="https://lynqro.com"> <img width="20%" align="center" src="${process.env.REACT_APP_LINK_SISTEMA}Logo-Lynqro-PDF.png" /> </a> </tr>
         </table>`,
        },
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        }
      )
      .then(() => {
        toggleMail();
        Swal.fire("Good job!", "Enviado con exito", "success");
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
          footer: `${error.response.data}`,
        });
        console.log(error);
      });
  }

  const editGasto = (event) => {
    const URL_GASTOS_EDIT = `${process.env.REACT_APP_URL_GASTOS}/${idEdit}`;
    event.preventDefault();

    axios
      .patch(
        URL_GASTOS_EDIT,
        {
            fecha: hoy,
            totalUSD,
            tipoCambio,
            total,
            abonos:0,
            saldo:total,
            descripcion,
            conceptosGastos:selectedConcepto,
            proveedores: selectedProveedor,
            moneda
        },
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        }
      )
      .then(() => {
        axios.post(
          URL_LOGS,
          {
            tipo: "Edit Gasto",
            detalle: `Fecha: ${fecha} / Descripcion: ${descripcion} `,
            user: user.id,
          },
          {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
            },
          }
        );
        toggleEdit();
        Swal.fire("Good job!", "Actualizado con exito", "success");
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
          footer: `${error.response.data}`,
        });
        console.log(error);
      });
  };

  const headers = [
    { name: `${t("Numero")}`, field: "numero", sortable: true },
    { name: `${t("Fecha")}`, field: "fecha", sortable: true },
    { name: `${t("Concepto")}`, field: "concepto", sortable: true },
    { name: `${t("Descripcion")}`, field: "descripcion", sortable: true },
    { name: "Proveedor", field: "proveedor", sortable: true },
    { name: `${t("Importe")}`, field: "total", sortable: true },
    { name: `${t("Validado")}`, field: "validado", sortable: false },
    { name: `${t("Autorizado")}`, field: "autorizado", sortable: false },
    { name: `${t("Editar")}`, field: "editar", sortable: false },
    { name: "Incluir PDF", field: "incluirPdf", sortable: false }, // ✅ checkbox para PDFTabla/Excel
  ];

  const commentsData = useMemo(() => {
    let computedComments = comments;

    if (search) {
      computedComments = computedComments.filter(
        (comment) =>
          comment.concepto.toLowerCase().includes(search.toLowerCase()) ||
          comment.proveedor.toLowerCase().includes(search.toLowerCase()) ||
          comment.validado.toLowerCase().includes(search.toLowerCase()) ||
          comment.autorizado.toLowerCase().includes(search.toLowerCase()) ||
          comment.descripcion.toLowerCase().includes(search.toLowerCase())
      );
    }

            if (selectedActivo) {
      computedComments = computedComments.filter((e) =>
        e.is_active.includes(selectedActivo)
      );
    }

    setTotalItems(computedComments.length);

    //Sorting comments
    if (sorting.field && sorting.field != "total") {
      const reversed = sorting.order === "asc" ? 1 : -1;
      computedComments = computedComments.sort(
        (a, b) => reversed * a[sorting.field].localeCompare(b[sorting.field])
      );
    }

    if (sorting.field && sorting.order === "asc" && sorting.field == "total") {
      computedComments = computedComments.sort((a, b) =>
        parseFloat(a[sorting.field]) > parseFloat(b[sorting.field]) ? 1 : -1
      );
    }

    if (sorting.field && sorting.order === "desc" && sorting.field == "total") {
      computedComments = computedComments.sort((a, b) =>
        parseFloat(a[sorting.field]) < parseFloat(b[sorting.field]) ? 1 : -1
      );
    }

    //Current Page slice
    return computedComments.slice(
      (currentPage - 1) * ITEMS_PER_PAGE,
      (currentPage - 1) * ITEMS_PER_PAGE + ITEMS_PER_PAGE
    );
  }, [
    comments,
    currentPage,
    search,
    sorting,
    selectedFechaInicio,
    selectedFechaFin,
    selectedActivo
  ]);



  const calcula = (e) => {
    setTotalUSD(e);
    setTotal(parseFloat(e) * parseFloat(tipoCambio));
  };

  const calculaTipoCambio = (e) => {
    setTipoCambio(e);
    setTotal(parseFloat(totalUSD) * parseFloat(e));
  };

  function cancelarGasto(idGasto) {
    Swal.fire({
      title: "Estas seguro?",
      text: "Se cancelara el Gasto!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Si, Cancelar!",
    }).then((result) => {
      if (result.isConfirmed) {
    axios
      .get(`${URL_GASTOS}Cancel/${idGasto}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then(() => {
        Swal.fire("Good job!", "Enviado con exito", "success");
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
          footer: `${error.response.data}`,
        });
        console.log(error);
      });
    }
  });
  }
  async function validadoGasto(
    idValida,
  ) {
  
        await axios
          .patch(
            `${URL_GASTOS}Validado/${idValida}`,
            {
              validado: "Si",
            },
            {
              headers: {
                Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
              },
            }
          )
          .then(() => {
            // toggle();
            Swal.fire("Good job!", "Actualizado con exito", "success");
            const newComments = comments.map((i) => {
              if (idValida === i._id) {
                i.validado = "Si"
              }
              return i;
            });
            setComments(newComments);
          })
          .catch((error) => {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: "Something went wrong!",
              footer: `${error.response.data}`,
            });
            console.log(error);
          });

  }

  async function validadoQuitarGasto(
    idValida,
  ) {
  
        await axios
          .patch(
            `${URL_GASTOS}Validado/${idValida}`,
            {
              validado: "No",
            },
            {
              headers: {
                Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
              },
            }
          )
          .then(() => {
            // toggle();
            Swal.fire("Good job!", "Actualizado con exito", "success");
            const newComments = comments.map((i) => {
              if (idValida === i._id) {
                i.validado = "No"
              }
              return i;
            });
            setComments(newComments);
          })
          .catch((error) => {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: "Something went wrong!",
              footer: `${error.response.data}`,
            });
            console.log(error);
          });

  }

  async function autorizadoGasto(
    idValida,
  ) {
  
        await axios
          .patch(
            `${URL_GASTOS}Autorizado/${idValida}`,
            {
              autorizado: "Si",
            },
            {
              headers: {
                Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
              },
            }
          )
          .then(() => {
            // toggle();
            Swal.fire("Good job!", "Actualizado con exito", "success");
            const newComments = comments.map((i) => {
              if (idValida === i._id) {
                i.autorizado = "Si"
              }
              return i;
            });
            setComments(newComments);
          })
          .catch((error) => {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: "Something went wrong!",
              footer: `${error.response.data}`,
            });
            console.log(error);
          });

  }

  async function autorizadoQuitarGasto(
    idValida,
  ) {
  
        await axios
          .patch(
            `${URL_GASTOS}Autorizado/${idValida}`,
            {
              autorizado: "No",
            },
            {
              headers: {
                Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
              },
            }
          )
          .then(() => {
            // toggle();
            Swal.fire("Good job!", "Actualizado con exito", "success");
            const newComments = comments.map((i) => {
              if (idValida === i._id) {
                i.autorizado = "No"
              }
              return i;
            });
            setComments(newComments);
          })
          .catch((error) => {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: "Something went wrong!",
              footer: `${error.response.data}`,
            });
            console.log(error);
          });

  }

  return (
    <>
      <Header />
      <br />
      <br />
      {user.menu_gastos ? (
        <div className="row">
          <div className="col-md-12">
            <div className="card style={{ width: 'auto' }}">
              <div className="card-body">
                <Row>
                  <Col md={7}>
                  {user.gastosCreate ? (
                <Button
                  size="sm"
                  type="submit"
                  className="btn btn-success"
                  href="/GastosCreate"
                >
                  {t("Nuevo Gasto")}
                </Button>
              ) : (
                <Button
                  size="sm"
                  type="submit"
                  className="btn btn-success"
                  disabled
                >
                  {t("Nuevo Gasto")}
                </Button>
              )}
                    <Button
                      size="sm"
                      href="/MenuCXP"
                      className="btn btn-danger"
                      id="botonListado"
                    >
                      {t("Regresar")}
                    </Button>
                  </Col>
                  <Col md={5}>
                    <ButtonGroup id="logoutBoton">
                      <Button
                        size="sm"
                        className="btn"
                        color="danger"
                        onClick={PDFTabla}
                      >
                        PDF <i class="far fa-file-pdf"></i>
                      </Button>
                      <Button
                        size="sm"
                        className="btn"
                        color="info"
                        onClick={toggleMail}
                      >
                        eMail <i class="fas fa-at"></i>
                      </Button>
                      <Button
                        size="sm"
                        className="btn"
                        color="primary"
                        onClick={excel}
                      >
                        Excel <i class="far fa-file-excel"></i>
                      </Button>
                    </ButtonGroup>
                  </Col>
                </Row>
                <Modal size="sm" isOpen={modalMail} toggle={toggleMail}>
                  <ModalHeader toggle={toggleMail}>
                    <h4>{t(<Header />)}</h4>
                  </ModalHeader>
                  <ModalBody>
                    <Label className="mr-sm-2">Email</Label>
                    <Input
                      className="col-sm-12"
                      type="text"
                      value={mailTo}
                      required
                      onChange={(e) => {
                        setMailTo(e.target.value);
                      }}
                    />
                  </ModalBody>
                  <ModalFooter>
                    <Button size="sm" color="success" onClick={enviaMail}>
                      {t("Enviar")}
                    </Button>
                  </ModalFooter>
                </Modal>
                <br />
                <h3 align="center">{t("Gastos")}</h3>
                <Row>
                  <Col md={2}>
                    <Label>{t("Fecha Inicio")}</Label>
                    <Input
                      bsSize="sm"
                      type="date"
                      value={selectedFechaInicio}
                      onChange={(e) => {
                        setSelectedFechaInicio(e.target.value);
                      }}
                    />
                  </Col>
                  <Col md={2}>
                    <Label>{t("Fecha Fin")}</Label>
                    <Input
                      bsSize="sm"
                      type="date"
                      value={selectedFechaFin}
                      onChange={(e) => {
                        setSelectedFechaFin(e.target.value);
                      }}
                    />
                  </Col>
                   <Col md={2}>
                                                  <Label className="mr-sm-2">{t("Activo")}</Label>
                                                  <Input
                                                    bsSize="sm"
                                                    type="select"
                                                    value={selectedActivo}
                                                    required
                                                    onChange={(e) => {
                                                      setSelectedActivo(e.target.value);
                                                    }}
                                                  >
                                                    <option value="">{t("Selecciona")}</option>
                                                    <option value="Si">{t("Activo")}</option>
                                                    <option value="No">{t("Cancelado")}</option>
                                                  </Input>
                                                </Col>
                </Row>
                <br />
                <div className="row">
                  <div className="col-md-6">
                    <Pagination
                      total={totalItems}
                      itemsPerPage={ITEMS_PER_PAGE}
                      currentPage={currentPage}
                      onPageChange={(page) => setCurrentPage(page)}
                    />
                  </div>
                  <div className="col-md-6 d-flex flex-row-reverse">
                    <Search
                      onSearch={(value) => {
                        setSearch(value);
                        setCurrentPage(1);
                      }}
                    />
                  </div>
                </div>
                <Button
                  size="sm"
                  color="secondary"
                  outline
                  style={{ width: "auto", display: "inline-block" }}
                  onClick={() => setExcludedPdfIds([])}
                >
                  Limpiar selección
                </Button>
                <br />
                <br />
                <Table
                  size="sm"
                  striped
                  borderless
                  className="table-responsive-xl"
                >
                  <TableHeader
                    headers={headers}
                    onSorting={(field, order) => setSorting({ field, order })}
                  />

                  <tbody>
                    {commentsData.map((c) => {
                      totalTabla = totalTabla + c.total;
                      if(c.is_active == "Si"){
                      return (
                        <tr>
                          <td>{c.numero}</td>
                          <td>{c.fecha}</td>
                          <td>{c.concepto}</td>
                          <td>{c.descripcion}</td>
                          <td>{c.proveedor}</td>
                          <td>
                            {new Intl.NumberFormat("en-US", {
                              style: "currency",
                              currency: "USD",
                              maximumFractionDigits: 2,
                              roundingIncrement: 5,
                            }).format(c.total)}
                          </td>
                          <td>
                          <Button
  size="sm"
  className="btn"
  color={c.validado === "No" ? "danger" : "primary"}
  disabled={!user?.validarGastos || c.validado !== "No"}
  onClick={() =>
    user?.validarGastos &&
    c.validado === "No" &&
    validadoGasto(c._id, c.idBanco)
  }
>
  {c.validado}
</Button>


                          </td>

                          <td>
                            <Button
  size="sm"
  className="btn"
  color={c.autorizado === "No" ? "danger" : "primary"}
  disabled={!user?.validarGastos}
  onClick={() =>
    user?.validarGastos &&
    (c.autorizado === "No"
      ? autorizadoGasto(c._id)
      : autorizadoQuitarGasto(c._id))
  }
>
  {c.autorizado}
</Button>

                          </td>
                          <td>
                            {c.saldo == c.total &&
                            c.validado == "No" &&
                            c.autorizado == "No" ? (
                              <Button
                                size="sm"
                                className="btn"
                                color="danger"
                                onClick={(e) => cancelarGasto(c._id)}
                              >
                                <i class="fas fa-ban"></i>
                              </Button>
                            ) : (
                              <Button
                                size="sm"
                                className="btn"
                                color="danger"
                                disabled
                                // onClick={(e) => cancelarGasto(c._id)}
                              >
                                <i class="fas fa-ban"></i>
                              </Button>
                            )}

                            {c.saldo == c.total &&
                            c.validado == "No" &&
                            c.autorizado == "No" ? (
                              <Button
                                color="info"
                                id="Editar"
                                size="sm"
                                onClick={(e) => {
                                  setIdEdit(c._id);
                                  setFecha(c.fecha);
                                  setTotalUSD(c.totalUSD);
                                  setTipoCambio(c.tipoCambio);
                                  setTotal(c.total);
                                  setDescripcion(c.descripcion);
                                  setSelectedConcepto(c.idConceptosGastos);
                                  setSelectedProveedor(c.idProveedor);
                                  setMoneda(c.moneda);
                                  toggleEdit();
                                }}
                              >
                                <i class="fas fa-edit"></i>
                              </Button>
                            ) : (
                              <Button
                                color="info"
                                id="Editar"
                                size="sm"
                                disabled
                              >
                                <i class="fas fa-edit"></i>
                              </Button>
                            )}
                          </td>
                          <td>
                            <input
                              type="checkbox"
                              checked={!excludedPdfIds.includes(String(c._id))}
                              onChange={(e) => {
                                const id = String(c._id);
                                const incluir = e.target.checked;
                                setExcludedPdfIds((prev) =>
                                  incluir
                                    ? prev.filter((x) => x !== id)
                                    : Array.from(new Set([...prev, id]))
                                );
                              }}
                            />
                          </td>
                        </tr>
                      );
                      }else{
                        return (
                        <tr style={{ backgroundColor: "#ed8c8c"}}>
                          <td>{c.numero}</td>
                          <td>{c.fecha}</td>
                          <td>{c.concepto}</td>
                          <td>{c.descripcion}</td>
                          <td>{c.proveedor}</td>
                          <td>
                            {/* {new Intl.NumberFormat("en-US", {
                              style: "currency",
                              currency: "USD",
                              maximumFractionDigits: 2,
                              roundingIncrement: 5,
                            }).format(c.total)} */}
                             CANCELADO
                          </td>
                          <td>

                          </td>
                          <td></td>
                          <td></td>
                          <td>
                            <input
                              type="checkbox"
                              checked={!excludedPdfIds.includes(String(c._id))}
                              onChange={(e) => {
                                const id = String(c._id);
                                const incluir = e.target.checked;
                                setExcludedPdfIds((prev) =>
                                  incluir
                                    ? prev.filter((x) => x !== id)
                                    : Array.from(new Set([...prev, id]))
                                );
                              }}
                            />
                          </td>
                        </tr>
                      );
                      }
                    })}
                    <tr>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td className="negrita" align="center">
                        TOTAL
                      </td>
                      <td className="negrita">
                        {new Intl.NumberFormat("en-US", {
                          style: "currency",
                          currency: "USD",
                          maximumFractionDigits: 2,
                          roundingIncrement: 5,
                        }).format(totalTabla)}
                      </td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                    </tr>
                  </tbody>
                </Table>
                <div className="col-md-6">
                  <Pagination
                    total={totalItems}
                    itemsPerPage={ITEMS_PER_PAGE}
                    currentPage={currentPage}
                    onPageChange={(page) => setCurrentPage(page)}
                  />
                </div>
              </div>
            </div>
          </div>

          <Modal size="lg" isOpen={modalEdit} toggle={toggleEdit}>
            <ModalHeader toggle={toggleEdit}>
              <h4> {t("Editar Gasto")}</h4>
            </ModalHeader>
            <ModalBody>
              <Row>
                <Col md={6}>
                  <Label className="mr-sm-2">{t("Fecha")}</Label>
                  <Input
                    type="date"
                    placeholder="Fecha"
                    value={fecha}
                    required
                    disabled
                  />
                </Col>
              
                <Col md={6}>
                  <Label className="mr-sm-2">Proveedor</Label>
                  <Input
                    // bsSize="sm"
                    type="select"
                    required
                    value={selectedProveedor}
                    disabled
                  >
                    <option value="0">{t("Selecciona")}</option>
                    {proveedores
                      .sort((a, b) => (a.name > b.name ? 1 : -1))
                      .map((a) => {
                        return <option value={a._id}>{a.name}</option>;
                      })}
                  </Input>
                </Col>

              
              </Row>

              <Row>
                <Col md={6}>
                  <Label className="mr-sm-2">{t("Concepto")}</Label>
                  <Input
                    // bsSize="sm"
                    type="select"
                    required
                    value={selectedConcepto}
                    onChange={(e) => setSelectedConcepto(e.target.value)}
                  >
                    <option value="0">{t("Selecciona")}</option>
                    {conceptosGastos
                      .sort((a, b) => (a.name > b.name ? 1 : -1))
                      .map((a) => {
                        return <option value={a._id}>{a.name}</option>;
                      })}
                  </Input>
                </Col>

                <Col md={6}>
                  <Label for="exampleEmail" className="mr-sm-2">
                    {t("Descripcion")}
                  </Label>
                  <Input
                    type="text"
                    placeholder="Descripcion"
                    value={descripcion}
                    required
                    onChange={(e) => {
                      setDescripcion(e.target.value);
                    }}
                  />
                </Col>
              </Row>
              <Row>
                <Col md={6}>
                    <Label className="mr-sm-2">{t("Moneda")}</Label>
                      <Input
                        type="select"
                        required
                        value={moneda}
                        onChange={(e) => {
                          setMoneda(e.target.value)
                        setTotalUSD(0)
                        setTotal(0)
                        setTipoCambio(1)}
                        }
                      >
                        <option value="MXN">{t("MXN")}</option>
                        <option value="USD">{t("USD")}</option>
                      </Input>
                      </Col>
                      </Row>
                      {moneda === "USD" ? (
                        
                        <Row>
                        <Col sm={4}>
                          <Label for="exampleEmail" className="mr-sm-2">
                            {t("Total USD")}
                          </Label>
                          <Input
                            type="number"
                            min="0"
                            step="any"
                            placeholder="TotalUSD"
                            value={totalUSD}
                            required
                            onChange={(e) => calcula(e.target.value)}
                          />
                        </Col>
                        <Col sm={4}>
                          <Label for="exampleEmail" className="mr-sm-2">
                            Tipo de Cambio
                          </Label>
                          <Input
                            type="number"
                            min="0"
                            step="any"
                            placeholder="TipoCambio"
                            value={tipoCambio}
                            required
                            onChange={(e) => calculaTipoCambio(e.target.value)}
                          />
                        </Col>
                        <Col sm={4}>
                          <Label for="exampleEmail" className="mr-sm-2">
                            {t("Total MXN")}
                          </Label>
                          <Input
                            type="number"
                            min="0"
                            step="any"
                            value={total}
                            disabled
                          />
                        </Col>
                      </Row>
                      ): (
                        
                        <Row>
                        <Col sm={4}>
                          <Label for="exampleEmail" className="mr-sm-2">
                            {t("Total MXN")}
                          </Label>
                          <Input
                            type="number"
                            min="0"
                            step="any"
                            value={total}
                            onChange={(e) => {setTotal(e.target.value)
                    setTotalUSD(e.target.value/tipoCambio)
                  }}
                          />
                        </Col>
                      </Row>
                      )}
            </ModalBody>
            <ModalFooter>
              <Button color="success" onClick={editGasto}>
                {t("Guardar")}
              </Button>
            </ModalFooter>
          </Modal>
        </div>
      ) : undefined}
      {loader}
    </>
  );
}

export default ListadoGastos;
